


























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';

/**
 * 绑定空间rg
 *
 * @author liyuyao
 * @date 08/11/2020
 */
@Component
export default class BindSpaceRgDialog extends Vue {
    @Prop({ default: false })
    visible: Boolean;

    show: Boolean = false;
    rgList: CommonTypes.UserInfoItem[] = [];

    formCustom: CommonTypes.mapObject = {
        rgId: null
    };

    btnLoading: Boolean = false;
    searchLoading: Boolean = false;
    $refs: any;

    get spaceId() {
        return parseInt(this.$route.params.id, 10);
    }

    @Watch('visible', { immediate: true })
    onShowChanged(val) {
        this.show = val;
        if (val) this.formCustom.rgId = null;
    }
    close() {
        this.$emit('update:visible', false);
    }
    async remoteMethod(query) {
        this.searchLoading = true;
        try {
            const res = await api.rgApi.getRgList({ name: query });
            this.rgList = res.data.items.map(item => {
                return {
                    name: item.name,
                    id: item.id
                };
            });
        } catch (e) {
            this.rgList = [];
            console.log(e);
        }
        this.searchLoading = false;
    }
    async submit() {
        if (this.btnLoading || !this.formCustom.rgId) {
            return;
        }
        this.btnLoading = true;
        try {
            const res = await api.spaceApi.bindSpaceRg({
                rgId: this.formCustom.rgId,
                spaceId: this.spaceId
            });
            const { code, data } = res;
            if (code === 200) {
                this.$mtd.message.success('绑定RG成功');
                this.$emit('success');
                this.close();
            } else if (code === 400) {
                this.cannotBindConfirm(data);
            }
            this.btnLoading = false;
        } catch (e) {
            this.btnLoading = false;
        }
    }
    cannotBindConfirm(data) {
        const adminStr = data.spaceAdmins.map(admin => {
            return `${admin.displayName}/${admin.username}`;
        });
        this.$mtd
            .confirm({
                title: `该服务组已绑定空间“${data.spaceName}”`,
                message: `请联系空间管理员：${adminStr.join('，')}；解绑后方可重新绑定`,
                width: '433px',
                showCancelButton: false,
                type: 'info',
                okButtonText: '确定'
            })
            .catch(e => e);
    }
}
